<template>
  <div class="auth-wrapper-provider">
    <SendCode
      v-if="state === 'SEND_CODE'"
      :label="$lang.forget_password"
      @goBack="goToAuth"
    />
    <ChangePassword v-if="state === 'CHANGE_PASSWORD'" />
  </div>
</template>

<script>
import SendCode from "./components/SendCode.vue";
import ChangePassword from "./components/ChangePassword.vue";
import { computed } from "vue";
import { goToRoute } from "@/shared/utils";
import { generateOtpCodeWt } from "@/modules/auth/services";

export default {
  name: "auth",
  components: {
    SendCode,
    ChangePassword,
  },
  provide() {
    // provide this data to all deep child components
    return {
      MOBILE: computed(() => this.mobile),
      CONTROL_CODE: computed(() => this.controlCode),
      EXPIRE_SECONDS: computed(() => this.expireSeconds),
      setState: this.setState,
      goToContactUs: this.goToContactUs,
      submitSendCode: this.submitSendCode,
    };
  },
  data() {
    return {
      state: "SEND_CODE",
      mobile: null,
      controlCode: null,
      expireSeconds: null,
    };
  },
  methods: {
    goToRoute,
    setMobile(mobile) {
      this.mobile = mobile;
    },
    setState(state) {
      this.state = state;
    },
    goToContactUs() {
      goToRoute("contact-us", {}, {}, false);
    },
    goToAuth() {
      goToRoute("auth", {}, {}, false);
    },
    async submitSendCode(mobileNumber, captcha, key) {
      try {
        const mode = "change_password";
        const response = await generateOtpCodeWt(
          mode,
          mobileNumber,
          captcha,
          key
        );
        const { mobile, controlCode, resExpireSeconds } = response;
        this.mobile = mobile;
        this.controlCode = controlCode;
        this.expireSeconds = resExpireSeconds;
        this.setState("CHANGE_PASSWORD");
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
